import { useMutation } from "@tanstack/react-query"
import { useNavigate, useSearchParams } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"

import { axios } from "../axios"
import { API_REGISTRATION_URL } from "../constants"
import { checkIsFailure } from "../utils/utils"
import { setToken } from "../../store/slices/auth"
import { RootState } from "../../store/store"
import {
  QUERY_PARAMS_EXCHANGE_TOKEN_KEY,
  ROUTES_PATHS,
} from "../../utils/constants"

interface RegistrationRequest {
  phoneNumber: string
}

interface RegistrationResponse {
  result: "Registered" | "OtpFlowRequired"
  token?: string
}

const registration = async (data: RegistrationRequest, token: string) => {
  const response = await axios(`${API_REGISTRATION_URL}`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    data,
  })

  if (checkIsFailure(response.status)) {
    throw new Error(
      `Ошибка при регистрации: ${response.status} - ${response.statusText}`,
    )
  }

  return response.data
}

export const useRegistration = () => {
  const token = useSelector((state: RootState) => state.auth.token)
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const dispatch = useDispatch()

  return useMutation<RegistrationResponse, Error, string>({
    mutationFn: (phoneNumber: string) =>
      registration(
        {
          phoneNumber: phoneNumber.replace(/\D/g, ""),
        },
        token || "",
      ),
    onSuccess: (data) => {
      if (data.token) {
        dispatch(setToken(data.token))
      }
      if (data.result === "Registered") {
        searchParams.set(
          "redirectUrl",
          `/${ROUTES_PATHS.topUpMbankAccountPayments}`,
        )
        searchParams.set(QUERY_PARAMS_EXCHANGE_TOKEN_KEY, data.token || "")

        navigate({
          pathname: `/${ROUTES_PATHS.auth}`,
          search: searchParams.toString(),
        })
      } else if (data.result === "OtpFlowRequired") {
        searchParams.set(
          "redirectUrl",
          `/${ROUTES_PATHS.topUpMbankAccountPayments}`,
        )

        navigate({
          pathname: `/${ROUTES_PATHS.topUpMbankAccountRegistrationOtp}`,
          search: searchParams.toString(),
        })
      }
    },
    onError: () => {
      navigate(`/${ROUTES_PATHS.error}`)
    },
  })
}
